import css from './index.module.scss';
import { LineSpace } from '@/componentsH5/ProductComponents';
import { BannerModule, TextWithImage } from '@/componentsH5/ProductDetailComponents';
import { getDetaileMoreProducts } from '@/utils';
import { useGlobal } from '@/utils/useGlobal';
import { getImageLocal } from '@/utils/locals';
import OtherList from '@/components/ProductCommon/OtherList';
import NextImage from '@/components/NextImage';

const product: any = {
    us: ['product_ps_river_river_pro_720', 'product_ps_delta_delta_1300', 'product_ps_delta_delta_max'],
    cis: ['product_ps_delta_delta_2', 'product_ps_delta_delta_pro', 'product_ps_delta_delta_max'],
    eu: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    uk: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    de: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    fr: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    it: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    es: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    tw: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    kr: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    cn: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    br: ['product_ps_river_river_256', 'product_ps_delta_delta_2', 'product_ps_delta_delta_2_max'],
    mx: ['product_ps_delta_delta_3_s', 'product_ps_delta_delta_2', 'product_ps_delta_delta_2_max'],
};

export default function SolarPanel() {
    const { gloproductlist, useLang, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('220wbifacialsolarpanel');
    const imgLocal = getImageLocal(locale, ['jp', 'de', 'fr', 'cn', 'cis']);
    const languageT = (value: string) => t(`solarpanels_220w.${value}`);
    const webpUrl = '/media/220W/h5/';

    return (
        <div className={`${css.animationWrapper} solarPanelModule`}>
            <div className="page-solarpanel-banner">
                <BannerModule
                    data={[
                        {
                            bgImgs: ['KV-220W-M.webp', 'KV-220W-M.png'],
                            title: languageT('title'),
                            des: languageT('des'),
                        },
                    ]}
                    config={{ isShowLogo: false, webpUrl }}
                />
            </div>
            <div className="banner-content">
                <div className="section section1">
                    <h3 className="tit">{languageT('second_bifacial')}</h3>
                    <div className="bg-img">
                        <NextImage
                            webpSrc={require('@publicLocal/product/solarpanel_220w/h5/Y-1.webp')}
                            src={require('@publicLocal/product/solarpanel_220w/h5/Y-1.png')}
                            className="fullImgs"
                            alt={languageT('second_bifacial')}
                        />
                    </div>
                </div>
                <div className="section section2">
                    <div className="sec2-top">
                        <div className="section sec2-top-l">
                            <h3
                                className="tit"
                                dangerouslySetInnerHTML={{
                                    __html: t.raw('solarpanels_220w.second_kickstand_case_h5'),
                                }}
                            ></h3>
                            <div className="bg-img">
                                <NextImage
                                    webpSrc={require('@publicLocal/product/solarpanel_220w/h5/Y-2.webp')}
                                    src={require('@publicLocal/product/solarpanel_220w/h5/Y-2.png')}
                                    className="fullImgs"
                                    alt={languageT('second_kickstand_case_h5')}
                                />
                            </div>
                        </div>
                        <div className="section sec2-top-r">
                            <h3
                                className="tit"
                                dangerouslySetInnerHTML={{
                                    __html: languageT('second_wide_compatibility_h5'),
                                }}
                            ></h3>
                            <div className="bg-img">
                                <NextImage
                                    webpSrc={require('@publicLocal/product/solarpanel_220w/h5/Y-3.webp')}
                                    src={require('@publicLocal/product/solarpanel_220w/h5/Y-3.png')}
                                    className="fullImgs"
                                    alt={languageT('second_wide_compatibility')}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="section sec2-btm">
                        <h3 className="tit">{languageT(locale === 'de' ? 'second_hight_efficiency_de_h5' : 'second_hight_efficiency')}</h3>
                        <div className="bg-img">
                            <NextImage
                                webpSrc={require('@publicLocal/product/solarpanel_220w/h5/Y-4.webp')}
                                src={require('@publicLocal/product/solarpanel_220w/h5/Y-4.png')}
                                className="fullImgs"
                                alt={languageT('second_hight_efficiency')}
                            />
                        </div>
                    </div>
                </div>
                <div className="section section3">
                    <h3 className="tit">
                        <span className="ipText">{languageT('second_waterproof')}</span>
                        <span className="ip">{languageT('second_ip')}</span>
                    </h3>
                    <div className="bg-img">
                        <NextImage
                            webpSrc={require('@publicLocal/product/solarpanel_220w/h5/Y-5.webp')}
                            src={require('@publicLocal/product/solarpanel_220w/h5/Y-5.png')}
                            className="fullImgs"
                            alt={languageT('second_waterproof')}
                        />
                    </div>
                </div>
            </div>
            <div className="textImg">
                <TextWithImage
                    config={{ isShowVideo: false, position: 'top', webpUrl }}
                    data={{
                        synopsis: languageT(locale === 'jp' ? 'third_title_h5' : 'third_title'),
                        desc: languageT('third_des'),
                        img_url: ['1.webp', '1.png'],
                        video_src: '',
                    }}
                />
            </div>
            <LineSpace height={1} background="transparent" />
            <div className="textImg">
                <TextWithImage
                    config={{
                        isShowVideo: false,
                        fullScreen: false,
                        position: 'top',
                        tip_margintop: '0.3rem',
                        webpUrl,
                    }}
                    data={{
                        synopsis: languageT(locale === 'jp' ? 'four_title_h5' : 'four_title'),
                        desc: languageT('four_des'),
                        img_url: ['mx'].includes(locale)
                            ? 'https://websiteoss.ecoflow.com/upload/image/1746696051671/220w_M.png'
                            : ['cis', 'sa'].includes(locale)
                            ? [`2_${locale === 'cis' ? 'ru' : 'sa-ar'}.webp`, `2_${locale === 'cis' ? 'ru' : 'sa-ar'}.jpg`]
                            : [`2_${imgLocal}.webp`, `2_${imgLocal}.jpg`],
                        tip: languageT('four_tip'),
                    }}
                />
            </div>
            <LineSpace height={1} background="transparent" />
            <div className="textImg item textImg1">
                <TextWithImage
                    config={{
                        isShowVideo: false,
                        fullScreen: false,
                        position: 'top',
                        text: 'left',
                        webpUrl,
                    }}
                    data={{
                        title: '',
                        synopsis: languageT('five_title'),
                        desc: `${languageT('five_des')}
                            <strong class="bb">${languageT('five_des_s')}</strong>
                            ${languageT('five_des1')}
                            <strong class="bb">${languageT('five_des_s1')}</strong>
                            ${languageT('five_des2')}
                                <strong class="bb">${languageT('five_des_s2')}</strong>
                            ${languageT('five_des3')}`,
                        tip: languageT('five_tip'),
                        arr: [
                            {
                                num: languageT('five_item_num'),
                                eum: languageT('five_item_eum'),
                                desc: languageT('five_item_desc'),
                            },
                            {
                                num: languageT('five_item_num1'),
                                eum: '',
                                desc: languageT('five_item_desc1'),
                            },
                        ],
                        img_url: ['3.webp', '3.png'],
                    }}
                />
            </div>
            <LineSpace height={1} background="transparent" />
            <div className="textImg">
                <TextWithImage
                    config={{ isShowVideo: false, fullScreen: false, position: 'top', webpUrl }}
                    data={{
                        synopsis: languageT('six_title'),
                        desc: languageT('six_des'),
                        img_url: ['4.webp', '4.png'],
                    }}
                />
            </div>
            <LineSpace height={1} background="transparent" />
            <div className="textImg">
                <TextWithImage
                    config={{ isShowVideo: false, fullScreen: false, position: 'top', webpUrl }}
                    data={{
                        synopsis: languageT(locale === 'jp' ? 'seven_title_h5' : 'seven_title'),
                        desc: languageT('seven_des_h5'),
                        img_url: ['5.webp', '5.png'],
                    }}
                />
            </div>
            <LineSpace height={1} background="transparent" />
            <div className="textImg ">
                <TextWithImage
                    config={{
                        isShowVideo: false,
                        fullScreen: false,
                        position: 'top',
                        tip_margintop: '0.15rem',
                        webpUrl,
                    }}
                    data={{
                        synopsis: languageT('eight_title'),
                        desc: languageT('eight_des'),
                        tip: languageT('eight_tip'),
                        img_url: ['6.webp', '6.png'],
                    }}
                />
            </div>
            <LineSpace height={1.2} background="transparent" />
            <OtherList
                data={getDetaileMoreProducts(
                    gloproductlist,
                    product[locale] || product.us,
                    '',
                    '',
                    `https://${locale}.ecoflow.com/collections/portable-power-stations`,
                )}
            />
        </div>
    );
}
